/* @flow */
import React from 'react'

import './style.css'

const ListItem = (props) => (
  <div {...props} className={ 'list-item ' + props.className }>
    { props.children }
  </div>
)

export default ListItem


// WEBPACK FOOTER //
// ./src/components/ListItem/index.js